import axiosLib from 'axios'
import store from '@/store'
import { getToken } from '@/base/utils/token'

// Create axios instance
const apiClient = axiosLib.create({
  baseURL: process.env.VUE_APP_API_URL || 'http://localhost:8000/api',
  timeout: 10000
})

// Add request interceptor for authentication
apiClient.interceptors.request.use(
  config => {
    // Don't add auth headers to login and register endpoints
    const isAuthEndpoint = config.url?.includes('/login') ||
                          config.url?.includes('/register') ||
                          config.url?.includes('/refresh')

    if (!isAuthEndpoint) {
      // Use localStorage as single source of truth
      const token = getToken()
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Add response interceptor for error handling only
apiClient.interceptors.response.use(
  response => {
    // Just pass through - let API calls handle their own data structure
    return response
  },
  error => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      store.dispatch('auth/logout')
      window.location.href = '/sign-in'
    }
    return Promise.reject(error)
  }
)

const init = async () => {
  // Initialize axios configuration
  return Promise.resolve()
}

// Add helper methods to axios instance
const addHeader = (name, value) => {
  apiClient.defaults.headers.common[name] = value
}

const removeHeader = (name) => {
  delete apiClient.defaults.headers.common[name]
}

// Export axios object with additional methods
export const axios = Object.assign(apiClient, {
  init,
  addHeader,
  removeHeader
})